/* BEON – HÅG Capisco configurator (8106 and Puls 8020) for the Kalles theme (vanilla JS, no dependencies).
 * Maps fabric / frame / lift / castors / foot ring choices onto the product's
 * "Price group" x "Base & lift" x "Extras" variants. Prices are always read from the
 * variants; the only arithmetic is the difference shown on "+$x" labels.
 * The theme's own (hidden) swatches are clicked to select the variant, so Kalles keeps
 * updating its price, Afterpay, add to cart / cart drawer, sticky bar and dynamic checkout.
 * Controls reuse Kalles' swatch markup (.t4s-swatch__option / __title / __list / __item). */
(function () {
  if (customElements.get('capisco-configurator')) return;

  var DOT = '·';
  var FRAMES = [
    { k: 'black', n: 'Black', code: 'MC011', sw: '#1f1f1f' },
    { k: 'white', n: 'White', code: 'MC010', sw: '#f4f4f2' },
    { k: 'silver', n: 'Silver', code: 'MC012', sw: 'linear-gradient(135deg,#e2e4e6,#9da1a5)' },
    { k: 'blush', n: 'Blush Rose', code: 'MC026', sw: '#d6b2a6' },
    { k: 'moss', n: 'Moss Grey', code: 'MC027', sw: '#878b79' }
  ];
  // base is always painted in the frame colour (polished / tumbled aluminium are not offered)
  var BASE = { n: 'Painted (frame colour)', v: 'Painted base' };
  var LIFTS = [
    { k: '150', n: '150 mm', sub: 'seat 41–54 cm' },
    { k: '200', n: '200 mm', sub: 'seat 47–65 cm' },
    { k: '265', n: '265 mm', sub: 'seat 56–81 cm' }
  ];
  var WHEELS = [
    { k: 'hard', n: 'Hard floors' },
    { k: 'soft', n: 'Soft floors / carpet' },
    { k: 'glides', n: 'Glides' },
    { k: 'universal', n: 'Universal castors' }
  ];
  var RING = [{ k: 'no', n: 'No' }, { k: 'yes', n: 'Yes' }];
  var OPT_NAMES = ['price group', 'base & lift', 'extras'];
  // the first option may also be called "Fabric group" (values "Group A · …" … "Group G · …")
  var OPT_ALIASES = { 'price group': ['fabric group'] };
  var RENDER_W = 830, RENDER_H = 989;
  // Side / Back views come from Flokk's render service (same parts list as the front layers);
  // they are only requested when the shopper taps the button
  var FLOKK_RENDER = 'https://flokk-cdn-image-prod.azureedge.net/process/renders/8106/';
  // same 830x989 framing as the rehosted front layers, so the chair keeps its size between views
  var VIEW_W = 830, VIEW_H = 989;
  var VIEWS = [{ k: 'front', n: 'Front' }, { k: 'left', n: 'Side' }, { k: 'back', n: 'Back' }];

  // "Extras" option value: foot ring and universal castors are the priced extras
  function extrasValue(s) {
    var ring = s.ring === 'yes', uni = s.wheels === 'universal';
    if (ring && uni) return 'Foot ring + Universal castors';
    if (uni) return 'Universal castors';
    return ring ? 'Foot ring' : 'None';
  }
  // price group number from an option value: "PG 3" -> "3", "Group C · Focus…" -> "3"
  function pgOf(s) {
    var t = norm(s), m = t.match(/^pg\s*(\d+)/);
    if (m) return m[1];
    m = t.match(/^(?:fabric\s+)?group\s+([a-z])\b/);
    if (m) return String(m[1].charCodeAt(0) - 96);
    m = t.match(/\d+/);
    return m ? m[0] : t;
  }
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[·•⋅]/g, DOT).replace(/\s+/g, ' ').trim();
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function find(arr, k) {
    for (var i = 0; i < arr.length; i++) if (arr[i].k === k) return arr[i];
    return arr[0];
  }
  function withWidth(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  /* a Kalles swatch item (div, as in the theme) made keyboard accessible */
  function item(cls) {
    var b = el('div', 't4s-swatch__item' + (cls ? ' ' + cls : ''));
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', 'false');
    b.tabIndex = 0;
    return b;
  }
  function onActivate(node, fn) {
    node.addEventListener('click', fn);
    node.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); }
    });
  }

  class CapiscoConfigurator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.product = JSON.parse(this.querySelector('[data-capcfg-product]').textContent);
        var dataEl = this.querySelector('script[id^="CapiscoData"]');
        this.lib = JSON.parse(dataEl.textContent);
        this.swatchBase = dataEl.getAttribute('data-swatch-base') || '';
        // per-model settings from the data snippet (8106 defaults when absent)
        this.lifts = this.lib.lifts || LIFTS;
        this.shells = this.lib.shells && this.lib.shells.length ? this.lib.shells : null;
        this.model = this.lib.label || 'HÅG Capisco 8106';
      } catch (e) {
        console.error('[capisco] data error', e);
        return;
      }
      this.formId = this.dataset.formId;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.composites = {};
      this.indexVariants();
      this.initState();
      this.renderChoices();
      this.renderRanges();
      this.bindSearch();
      // property inputs live inside the theme's product form, so add to cart (ajax / cart drawer),
      // the sticky add-to-cart bar and the dynamic checkout button all carry them
      var form = document.getElementById(this.formId);
      this.propInputs = Array.prototype.slice.call(this.querySelectorAll('[data-capcfg-prop]'));
      this.propInputs.forEach(function (i) { if (form) form.appendChild(i); });
      this.setupGallery();
      this.update(true);
      // Kalles initialises its variant picker on load; select the configured variant afterwards
      // (the gallery keeps the product's own first photo until the shopper changes something)
      var self = this, sync = function () { setTimeout(function () { self.syncTheme(); }, 0); };
      if (document.readyState === 'complete') sync();
      else window.addEventListener('load', sync, { once: true });
    }

    /* ---------- variants ---------- */
    indexVariants() {
      var opts = (this.product.options || []).map(norm);
      this.pos = OPT_NAMES.map(function (n) {
        var i = opts.indexOf(n);
        (OPT_ALIASES[n] || []).forEach(function (a) { if (i < 0) i = opts.indexOf(a); });
        return i;
      });
      this.valid = this.pos.every(function (p) { return p > -1; });
      this.map = {};
      var self = this;
      (this.product.variants || []).forEach(function (v) {
        var key = self.pos.map(function (p, i) { return i === 0 ? pgOf(v[1 + p]) : norm(v[1 + p]); }).join('|');
        self.map[key] = { id: v[0], o: [v[1], v[2], v[3]], price: v[4], compare: v[5], available: v[6] === 1 };
      });
      if (!this.valid) console.warn('[capisco] product options must be named "Price group", "Base & lift", "Extras"');
    }
    values(s) {
      var range = this.lib.ranges[s.range];
      return [String(range.pg), BASE.v + ' ' + DOT + ' ' + s.lift + ' mm', extrasValue(s)];
    }
    variantFor(s) {
      if (!this.valid) return null;
      return this.map[this.values(s).map(function (x, i) { return i === 0 ? String(x) : norm(x); }).join('|')] || null;
    }
    withState(patch) {
      var s = Object.assign({}, this.state, patch);
      if (s.lift === '150') s.ring = 'no';
      return s;
    }
    money(cents) {
      var formats = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.']
      };
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        var f = formats[k] || formats.amount;
        var parts = (Math.abs(cents) / 100).toFixed(f[0]).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f[1]);
        return parts.join(f[2]);
      });
    }
    /* "+$x" label: price with the choice minus price with the reference choice (both from variants). */
    delta(patch, refPatch, zeroText) {
      var a = this.variantFor(this.withState(patch));
      var b = this.variantFor(this.withState(refPatch));
      if (!a || !b) return '';
      var d = a.price - b.price;
      if (d === 0) return zeroText || '';
      // whole-dollar surcharges are shown without cents (+$145, not +$145.00)
      return (d > 0 ? '+' : '−') + this.money(d).replace(/[.,]00(?=\D*$)/, '');
    }

    /* ---------- state ---------- */
    initState() {
      this.state = { range: 0, colour: 0, frame: 'black', lift: '200', wheels: 'hard', ring: 'no', shell: this.shells ? this.shells[0].k : '' };
      var vid = new URLSearchParams(location.search).get('variant');
      if (!vid || !this.valid) return;
      var v = null, self = this;
      Object.keys(this.map).forEach(function (k) { if (String(self.map[k].id) === vid) v = self.map[k]; });
      if (!v) return;
      var o = this.pos.map(function (p) { return norm(v.o[p]); });
      var pg = pgOf(o[0]);
      var ri = this.lib.ranges.findIndex(function (r) { return r.pg === pg; });
      if (ri > -1) this.state.range = ri;
      var m = o[1].match(/ (\d+) mm$/);
      if (m) this.state.lift = m[1];
      this.state.ring = o[2].indexOf('foot ring') > -1 ? 'yes' : 'no';
      if (o[2].indexOf('universal') > -1) this.state.wheels = 'universal';
    }
    set(patch) {
      this.state = this.withState(patch);
      this.view = 'front';
      this.update();
      this.syncTheme();
      this.renderGallery();
    }

    /* ---------- drive Kalles' own (hidden) variant swatches ---------- */
    syncTheme() {
      var v = this.variantFor(this.state);
      var form = document.getElementById(this.formId);
      if (!v || !form) return;
      var select = form.querySelector('select[name="id"]');
      var opts = form.querySelectorAll('[data-swatch-option]');
      var self = this;
      var pickAll = function (order) {
        order.forEach(function (i) {
          var o = opts[i];
          if (!o) return;
          var want = norm(v.o[i]);
          var it = Array.prototype.find.call(o.querySelectorAll('[data-swatch-item]'), function (x) {
            return norm(x.getAttribute('data-value')) === want;
          });
          if (it && !it.classList.contains('is--selected')) it.click();
        });
      };
      if (select && select.value !== String(v.id)) pickAll([0, 1, 2]);
      // a transient combination (e.g. 150 mm + foot ring) can leave the theme elsewhere: retry in reverse
      if (select && select.value !== String(v.id)) pickAll([2, 1, 0]);
      if (select && select.value !== String(v.id)) {
        select.value = String(v.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (v.id !== this.lastId) {
        this.lastId = v.id;
        try {
          var url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }
    }

    /* ---------- gallery: show the selected fabric x frame as the first product image ----------
       Sources, in order: BEON's own 8106 photo for that fabric + frame; the layered Flokk front
       render (composited into one image on a canvas); otherwise (no picture, or a render layer
       failed to load) the 8106 outline drawing with the fabric swatch plus the options.
       Side / Back buttons swap in Flokk's side / back render on demand. The first slide's image
       and the PhotoSwipe zoom source (data-pswp-src) are pointed at that picture; the first
       thumbnail and the sticky-bar image always show the front (see updateThumb), so Kalles'
       slider, thumbnails and zoom keep working untouched. */
    galleryInfo(s) {
      var g = this.lib.gallery;
      if (!g) return null;
      var c = this.lib.ranges[s.range].c[s.colour][0];
      var fi = g.photo_frames.indexOf(s.frame);
      var ph = g.photos[this.shells ? c + '|' + s.shell : c];
      if (ph && fi > -1 && ph[fi]) {
        return { type: 'photo', src: g.photo_base + ph[fi].replace('~', g.photo_tilde) };
      }
      if (this.hasRender(s)) {
        return { type: 'render', layers: this.layerNames(s).map(function (l) { return g.render_base + l + '.png'; }) };
      }
      return { type: 'chip' };
    }
    hasRender(s) {
      var g = this.lib.gallery, c = this.lib.ranges[s.range].c[s.colour][0];
      return !!(g && g.render_base && (g.render_missing || []).indexOf(c) === -1);
    }
    /* Flokk render parts for the selection (front layers in Files and the render service share them) */
    layerNames(s) {
      var c = this.lib.ranges[s.range].c[s.colour][0];
      var mc = find(FRAMES, s.frame).code.toLowerCase();
      if (this.shells) {
        // Puls 8020 layer order (shell over the cushion, base after the castors)
        var sh = String(s.shell || this.shells[0].k).toLowerCase();
        return ['parts', 'fabric_' + c.toLowerCase(), 'shell_back_' + sh, 'shell_seat_' + sh, 'jbar_' + mc, 'lift_' + mc]
          .concat(s.wheels === 'glides' ? ['stands', 'reflex_stands_reflex'] :
            s.wheels === 'universal' ? ['wheels_ca016', 'reflex_ca016'] : ['wheels', 'reflex_wheels_reflex'])
          .concat(['footbase_' + mc])
          .concat(s.ring === 'yes' ? ['footring_' + mc] : []);
      }
      return ['parts', 'fabric_' + c.toLowerCase(), 'jbar_' + mc, 'lift_' + mc, 'footbase_' + mc]
        .concat(s.ring === 'yes' ? ['footring_' + mc] : [])
        .concat(s.wheels === 'glides' ? ['stands', 'reflex_stands_reflex'] : ['wheels', 'reflex_wheels_reflex']);
    }
    viewUrl(s, view, w, h) {
      return (this.lib.view_base || FLOKK_RENDER) + view + '.jpg?parts=' + this.layerNames(s).join(',') +
        '&sourceFormat=png&v=20&width=' + w + '&height=' + h + '&scalingMode=fit';
    }
    setupGallery() {
      var root = this.closest('[data-product-featured]') || document;
      this.gRoot = root;
      // scopes the fixed-ratio gallery styles to this product only
      if (root.classList) root.classList.add('capcfg-gallery');
      this.gMedia = root.querySelector('[data-main-media]');
      var first = this.gMedia && this.gMedia.querySelector('[data-main-slide]');
      this.gBox = first && first.querySelector('.t4s-product__media');
      this.gImg = this.gBox && this.gBox.querySelector('img');
      if (!this.gImg) return;
      this.view = 'front';
      this.viewFailed = {};
      this.buildViews();
      var i = this.gImg;
      this.gOrig = {
        master: i.getAttribute('data-master'),
        w: i.getAttribute('width'),
        h: i.getAttribute('height'),
        alt: i.getAttribute('alt')
      };
    }
    composite(layers) {
      var key = layers.join('|');
      if (this.composites[key]) return this.composites[key];
      var p = Promise.all(layers.map(function (u) {
        return new Promise(function (res, rej) {
          var im = new Image();
          im.crossOrigin = 'anonymous';
          im.decoding = 'async';
          im.onload = function () { res(im); };
          im.onerror = function () { rej(new Error('layer ' + u)); };
          im.src = withWidth(u, RENDER_W);
        });
      })).then(function (imgs) {
        var cv = document.createElement('canvas');
        cv.width = RENDER_W;
        cv.height = RENDER_H;
        var ctx = cv.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, RENDER_W, RENDER_H);
        imgs.forEach(function (im) { ctx.drawImage(im, 0, 0, RENDER_W, RENDER_H); });
        // thumbnail: the chair cropped to its own bounds and centred in a square, so it fills the
        // thumbnail like the BEON photos do (the full render keeps Flokk's framing for the main slide)
        var px = ctx.getImageData(0, 0, RENDER_W, RENDER_H).data, x0 = RENDER_W, y0 = RENDER_H, x1 = -1, y1 = -1;
        for (var y = 0; y < RENDER_H; y += 2) {
          for (var x = 0; x < RENDER_W; x += 2) {
            var o = (y * RENDER_W + x) * 4;
            if (px[o] < 240 || px[o + 1] < 240 || px[o + 2] < 240) {
              if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
        }
        if (x1 < 0) { x0 = 0; y0 = 0; x1 = RENDER_W - 1; y1 = RENDER_H - 1; }
        var T = 240, bw = x1 - x0 + 1, bh = y1 - y0 + 1, k = Math.min(T * 0.92 / bw, T * 0.92 / bh);
        var tc = document.createElement('canvas');
        tc.width = T;
        tc.height = T;
        var tctx = tc.getContext('2d');
        tctx.fillStyle = '#ffffff';
        tctx.fillRect(0, 0, T, T);
        tctx.drawImage(cv, x0, y0, bw, bh, (T - bw * k) / 2, (T - bh * k) / 2, bw * k, bh * k);
        var blob = function (c, q) {
          return new Promise(function (res, rej) {
            c.toBlob(function (b) { b ? res(URL.createObjectURL(b)) : rej(new Error('toBlob')); }, 'image/jpeg', q);
          });
        };
        return Promise.all([blob(cv, 0.9), blob(tc, 0.9)]).then(function (u) { return { url: u[0], thumb: u[1] }; });
      });
      this.composites[key] = p;
      p.catch(function () { delete this.composites[key]; }.bind(this));
      return p;
    }
    setImg(img, src, w, h) {
      if (!img) return;
      img.removeAttribute('data-srcset');
      img.removeAttribute('srcset');
      img.src = src;
      if (w) { img.setAttribute('width', w); img.setAttribute('height', h); }
    }
    thumbImg() {
      var nav = this.gRoot.querySelector('.t4s-carousel__nav');
      var it = nav && nav.querySelector('.t4s-carousel__nav-item');
      return it ? it.querySelector('img') : null;
    }
    /* outline fallback: the HÅG 8106 line drawing (snippets/capisco-outline.liquid, via a
       <template>) with the selected swatch tile, and the chosen options listed underneath */
    showOutline(on) {
      var box = this.gBox.querySelector('.capcfg-outline-box');
      if (!on) { if (box) box.remove(); return; }
      var tpl = this.querySelector('template[data-capcfg-outline]');
      if (!box) {
        box = el('div', 'capcfg-outline-box');
        if (tpl) box.appendChild(tpl.content.cloneNode(true));
        box.appendChild(el('ul', 'capcfg-outline-box__list'));
        this.gBox.appendChild(box);
      }
      var s = this.state, r = this.lib.ranges[s.range], c = r.c[s.colour];
      var sw = box.querySelector('[data-capcfg-swatch]');
      if (sw) sw.style.backgroundImage = 'url("' + this.swatchUrl(c[0]) + '")';
      var list = box.querySelector('ul');
      list.textContent = '';
      [
        r.n + ' ' + c[1] + ' ' + DOT + ' ' + c[0],
        find(FRAMES, s.frame).n + ' frame',
        find(this.lifts, s.lift).n + ' gas lift',
        find(WHEELS, s.wheels).n,
        s.ring === 'yes' ? 'Foot ring' : 'No foot ring'
      ].concat(this.shells ? [find(this.shells, s.shell).n + ' shell'] : []).forEach(function (t) { list.appendChild(el('li', null, t)); });
    }
    /* original product image underneath, outline on top (thumbnail / zoom keep the original) */
    showFallback() {
      var o = this.gOrig, img = this.gImg;
      img.setAttribute('data-master', o.master);
      img.removeAttribute('data-pswp-src');
      img.removeAttribute('data-pswp-w');
      img.removeAttribute('data-pswp-h');
      this.setImg(img, withWidth(o.master, 1200), o.w, o.h);
      img.alt = o.alt || '';
      this.showOutline(true);
      this.toFirstSlide();
    }
    /* Front / Side / Back buttons under the main image (Kalles option-button markup) */
    buildViews() {
      var self = this, host = this.gMedia.parentNode;
      var wrap = el('div', 't4s-swatch capcfg-views');
      var list = el('div', 't4s-swatch__list');
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-label', 'View');
      this.viewEls = VIEWS.map(function (v) {
        var b = item();
        b.textContent = v.n;
        b.dataset.view = v.k;
        onActivate(b, function () {
          if (b.classList.contains('is--unavailable') || self.view === v.k) return;
          self.view = v.k;
          self.renderGallery();
        });
        list.appendChild(b);
        return b;
      });
      wrap.appendChild(list);
      host.insertBefore(wrap, this.gMedia.nextSibling);
      this.syncViews();
    }
    syncViews() {
      if (!this.viewEls) return;
      var s = this.state, self = this, render = this.hasRender(s);
      var base = this.layerNames(s).join(',');
      if (!render) this.view = 'front';
      this.viewEls.forEach(function (b) {
        var k = b.dataset.view, failed = !!self.viewFailed[k + '|' + base];
        b.hidden = k !== 'front' && !render;
        b.classList.toggle('is--unavailable', failed);
        b.setAttribute('aria-disabled', failed ? 'true' : 'false');
        b.classList.toggle('is--selected', self.view === k);
        b.setAttribute('aria-checked', self.view === k ? 'true' : 'false');
      });
    }
    renderGallery() {
      if (!this.gImg) return;
      var s = this.state, info = this.galleryInfo(s);
      if (!info) return;
      this.syncViews();
      this.updateThumb(s, info);
      if (this.view !== 'front') info = { type: 'view', view: this.view, src: this.viewUrl(s, this.view, VIEW_W, VIEW_H) };
      var key = JSON.stringify(info);
      if (key === this.galKey) return;
      this.galKey = key;
      var r = this.lib.ranges[s.range], c = r.c[s.colour], self = this;
      var label = this.model + ' – ' + r.n + ' ' + c[1] + ' (' + c[0] + '), ' + find(FRAMES, s.frame).n + ' frame';
      var img = this.gImg;
      var apply = function (main, zoom, thumb, w, h) {
        if (self.galKey !== key) return;
        self.showOutline(false);
        self.setImg(img, main, w, h);
        img.alt = label;
        img.setAttribute('data-master', zoom);
        img.setAttribute('data-pswp-src', zoom);
        img.setAttribute('data-pswp-w', w);
        img.setAttribute('data-pswp-h', h);
        self.toFirstSlide();
      };
      if (info.type === 'view') {
        // Flokk side / back render, loaded on demand; if it fails, back to the front view
        var pv = new Image();
        pv.onload = function () {
          apply(info.src, info.src, null, VIEW_W, VIEW_H);
        };
        pv.onerror = function () {
          if (self.galKey !== key) return;
          self.viewFailed[info.view + '|' + self.layerNames(s).join(',')] = true;
          self.view = 'front';
          self.renderGallery();
        };
        pv.src = info.src;
      } else if (info.type === 'photo') {
        // keep the current picture until the photo has loaded (no blank flash)
        var pre = new Image();
        var main = withWidth(info.src, 1200);
        pre.onload = pre.onerror = function () {
          var w = pre.naturalWidth || 1200, h = pre.naturalHeight || 1200;
          apply(main, withWidth(info.src, 1800), null, w, h);
        };
        pre.src = main;
      } else if (info.type === 'render') {
        this.composite(info.layers).then(function (r) {
          apply(r.url, r.url, null, RENDER_W, RENDER_H);
        }).catch(function (e) {
          console.warn('[capisco] render', e);
          if (self.galKey === key) self.showFallback();
        });
      } else {
        // no picture for this fabric: chair outline with the swatch
        this.showFallback();
      }
    }
    /* first thumbnail + sticky-bar image always show the FRONT of the configured chair (whatever
       view the main slide shows); only the image source changes, never the thumbnail box */
    updateThumb(s, front) {
      var key = JSON.stringify(front);
      if (key === this.thumbKey) return;
      this.thumbKey = key;
      var self = this, set = function (src) {
        if (self.thumbKey !== key) return;
        self.setImg(self.thumbImg(), src);
        self.setImg(document.querySelector('.t4s-sticky-atc__img img'), src);
      };
      if (front.type === 'photo') set(withWidth(front.src, 240));
      else if (front.type === 'render') {
        this.composite(front.layers).then(function (r) { set(r.thumb); }, function () { set(withWidth(self.gOrig.master, 240)); });
      } else set(withWidth(this.gOrig.master, 240));
    }
    toFirstSlide() {
      var F = window.Flickityt4s;
      var f = F && F.data && this.gMedia ? F.data(this.gMedia) : null;
      if (f && f.selectedIndex) f.select(0);
    }

    /* ---------- rendering: option items (Kalles pills / colour swatches) ---------- */
    option(group, it) {
      var b;
      if (group === 'frame' || group === 'shell') {
        b = item('is-sw__color capcfg__frame');
        b.style.background = it.sw;
        b.title = it.n;
        b.setAttribute('aria-label', it.n);
      } else {
        b = item();
        b.appendChild(document.createTextNode(it.n));
        b.appendChild(el('span', 'capcfg__delta'));
      }
      var self = this;
      onActivate(b, function () {
        if (b.classList.contains('is--unavailable')) return;
        var p = {}; p[group] = it.k; self.set(p);
      });
      return { el: b, k: it.k };
    }
    renderChoices() {
      var self = this;
      this.opts = {};
      var groups = { frame: FRAMES, lift: this.lifts, wheels: WHEELS, ring: RING };
      var shellStep = this.querySelector('[data-step="shell"]');
      if (this.shells && shellStep) groups = Object.assign({ shell: this.shells }, groups);
      else if (shellStep) shellStep.hidden = true;
      Object.keys(groups).forEach(function (g) {
        var box = self.querySelector('[data-capcfg-group="' + g + '"]');
        if (!box) return;
        box.setAttribute('role', 'radiogroup');
        self.opts[g] = groups[g].map(function (it) {
          var o = self.option(g, it);
          box.appendChild(o.el);
          return o;
        });
      });
    }

    /* ---------- rendering: fabric ranges (collapsible, swatches built lazily) ---------- */
    renderRanges() {
      var self = this;
      var wrap = this.querySelector('[data-capcfg-ranges]');
      this.rangeEls = this.lib.ranges.map(function (r, i) {
        var d = el('details', 'capcfg__range');
        var s = el('summary');
        var t = el('span', 'capcfg__range-text');
        var title = el('span', 'capcfg__range-title', r.n);
        title.appendChild(el('span', 'capcfg__muted', ' ' + r.mill));
        t.appendChild(title);
        t.appendChild(el('span', 'capcfg__range-mat', r.mat));
        s.appendChild(t);
        var meta = el('span', 'capcfg__range-meta');
        meta.appendChild(el('span', 'capcfg__delta'));
        meta.appendChild(el('span', null, r.c.length + (r.c.length === 1 ? ' colour' : ' colours')));
        s.appendChild(meta);
        d.appendChild(s);
        var list = el('div', 't4s-swatch__list');
        list.setAttribute('role', 'radiogroup');
        d.appendChild(list);
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          self.buildSwatches(i);
          // one open range at a time (outside search), so the list never needs its own scroll box
          if (!self.query) self.rangeEls.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        });
        wrap.appendChild(d);
        return d;
      });
      this.rangeEls[this.state.range].open = true;
      this.buildSwatches(this.state.range);
    }
    swatchUrl(code) {
      var file = (this.lib.swatch_override && this.lib.swatch_override[code]) || ('flokk-swatch-' + code.toLowerCase() + '.png');
      return this.swatchBase + file + '?width=112';
    }
    buildSwatches(i) {
      var d = this.rangeEls[i];
      var box = d.querySelector('.t4s-swatch__list');
      if (box.childElementCount) return;
      var r = this.lib.ranges[i], self = this;
      r.c.forEach(function (c, j) {
        var b = item('is-sw__color capcfg__fabric');
        b.dataset.range = i;
        b.dataset.j = j;
        b.title = c[1] + ' ' + DOT + ' ' + c[0];
        b.setAttribute('aria-label', r.n + ', ' + c[1] + ' ' + c[0]);
        b.dataset.search = norm(c[0] + ' ' + c[1]);
        b.style.backgroundImage = 'url("' + self.swatchUrl(c[0]) + '")';
        var sel = self.state.range === i && self.state.colour === j;
        b.classList.toggle('is--selected', sel);
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
        onActivate(b, function () { self.set({ range: i, colour: j }); });
        box.appendChild(b);
      });
      if (this.query) this.filterSwatches(d, this.query);
    }

    /* ---------- search ---------- */
    bindSearch() {
      var input = this.querySelector('[data-capcfg-search]');
      var self = this, t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { self.search(norm(input.value)); }, 120);
      });
    }
    filterSwatches(d, q) {
      d.querySelectorAll('.capcfg__fabric').forEach(function (b) {
        b.hidden = !!q && b.dataset.search.indexOf(q) === -1;
      });
    }
    search(q) {
      this.query = q;
      var any = false, self = this;
      this.lib.ranges.forEach(function (r, i) {
        var d = self.rangeEls[i];
        if (!q) {
          d.hidden = false;
          d.open = i === self.state.range;
          if (d.open) self.buildSwatches(i);
          self.filterSwatches(d, '');
          return;
        }
        var rangeHit = norm(r.n + ' ' + r.mill + ' ' + r.mat).indexOf(q) > -1;
        var colourHit = r.c.some(function (c) { return norm(c[0] + ' ' + c[1]).indexOf(q) > -1; });
        d.hidden = !(rangeHit || colourHit);
        if (!d.hidden) any = true;
        if (colourHit && !rangeHit) { d.open = true; self.buildSwatches(i); self.filterSwatches(d, q); }
        else { self.filterSwatches(d, ''); if (rangeHit) d.open = false; }
      });
      this.querySelector('[data-capcfg-empty]').hidden = !q || any;
    }

    /* ---------- update everything from state ---------- */
    update() {
      var s = this.state, self = this;
      var r = this.lib.ranges[s.range], c = r.c[s.colour];
      var frame = find(FRAMES, s.frame);
      var lift = find(this.lifts, s.lift), wheels = find(WHEELS, s.wheels);
      var v = this.variantFor(s);

      // selected / unavailable states and +$ labels
      var ringBlocked = s.lift === '150';
      var deltas = {
        // coupled options are held neutral so a label shows only that choice's own surcharge;
        // gas lift is measured against the included 200 mm lift
        frame: function (k) { return self.delta({ frame: k, ring: 'no' }, { frame: 'black', ring: 'no' }); },
        lift: function (k) { return self.delta({ lift: k, ring: 'no' }, { lift: '200', ring: 'no' }); },
        wheels: function (k) { return self.delta({ wheels: k }, { wheels: 'hard' }); },
        ring: function (k) { return self.delta({ ring: k }, { ring: 'no' }); },
        shell: function () { return ''; }
      };
      var current = { frame: s.frame, lift: s.lift, wheels: s.wheels, ring: s.ring, shell: s.shell };
      var labels = {};
      Object.keys(this.opts).forEach(function (g) {
        self.opts[g].forEach(function (o) {
          var k = o.k;
          var disabled = g === 'ring' && k === 'yes' && ringBlocked;
          if (!disabled && self.valid) {
            var p = {}; p[g] = k;
            if (!self.variantFor(self.withState(p))) disabled = true;
          }
          var d = disabled ? '' : deltas[g](k);
          var on = current[g] === k;
          o.el.classList.toggle('is--selected', on);
          o.el.setAttribute('aria-checked', on ? 'true' : 'false');
          o.el.classList.toggle('is--unavailable', disabled);
          o.el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          var dEl = o.el.querySelector('.capcfg__delta');
          if (dEl) dEl.textContent = d;
          else o.el.title = find(g === 'shell' ? self.shells : FRAMES, k).n + (d ? ' ' + d : '');
          if (on) labels[g] = d;
        });
      });
      this.querySelector('[data-capcfg-ringhint]').hidden = !ringBlocked;

      // fabric ranges: price label relative to the lowest price group
      var minPg = this.lib.ranges.reduce(function (m, x) { return Math.min(m, +x.pg); }, 99);
      var refRange = this.lib.ranges.findIndex(function (x) { return +x.pg === minPg; });
      this.rangeEls.forEach(function (d, i) {
        d.classList.toggle('is-selected', i === s.range);
        d.querySelector('.capcfg__delta').textContent = self.delta({ range: i }, { range: refRange }, 'Included');
        d.querySelectorAll('.capcfg__fabric').forEach(function (b) {
          var on = i === s.range && +b.dataset.j === s.colour;
          b.classList.toggle('is--selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });

      // option titles (Kalles style: "OPTION: VALUE") + summary
      var vals = {
        fabric: r.n + ' ' + c[1] + ' ' + c[0],
        shell: this.shells ? find(this.shells, s.shell).n : '',
        frame: frame.n + (labels.frame ? ' (' + labels.frame + ')' : ''),
        lift: lift.n + ' ' + DOT + ' ' + lift.sub,
        wheels: wheels.n,
        ring: s.ring === 'yes' ? 'Yes' : 'No'
      };
      Object.keys(vals).forEach(function (k) {
        var n = self.querySelector('[data-capcfg-value="' + k + '"]');
        if (n) n.textContent = vals[k];
      });
      this.querySelector('[data-capcfg-summary]').textContent = [
        r.n + ' (' + r.mill + ') – ' + c[1] + ' (' + c[0] + ')',
        (this.shells ? find(this.shells, s.shell).n + ' shell ' + DOT + ' ' : '') + frame.n + ' frame', BASE.n, lift.n + ' gas lift', wheels.n
      ].concat(s.ring === 'yes' ? ['Foot ring'] : []).join(' ' + DOT + ' ');

      // line-item properties
      var gi = this.galleryInfo(s);
      var props = {
        'FABRIC': r.n + ' (' + r.mill + ')',
        'COLOUR': c[1] + ' ' + DOT + ' ' + c[0],
        'SHELL': this.shells ? find(this.shells, s.shell).n + ' ' + DOT + ' ' + s.shell : '',
        'FRAME': frame.n,
        'BASE': BASE.n,
        'GAS LIFT': lift.n + ' (' + lift.sub + ')',
        'WHEELS': wheels.n,
        'FOOTRING': s.ring === 'yes' ? 'Yes' : 'No',
        '_Flokk code': c[0] + (this.shells ? ' / ' + s.shell : '') + ' / ' + frame.code,
        // _preview is always one image on BEON's CDN (BEON photo, else the fabric swatch);
        // _render lists the render layers so the cart can rebuild the configured chair
        '_preview': gi && gi.type === 'photo' ? withWidth(gi.src, 600) : this.swatchUrl(c[0]),
        '_render': gi && gi.type === 'render' ? gi.layers.map(function (u) {
          return u.slice(self.lib.gallery.render_base.length).replace(/\.png$/, '');
        }).join(',') : ''
      };
      // empty properties are left out of the cart line (disabled inputs are not submitted)
      this.propInputs.forEach(function (i) {
        i.value = props[i.dataset.capcfgProp] || '';
        i.disabled = !i.value;
      });

      this.renderPrice(v);
    }

    /* summary price in Kalles' markup (del / ins / .t4s-badge-price) */
    renderPrice(v) {
      var err = this.querySelector('[data-capcfg-error]');
      var priceEl = this.querySelector('[data-capcfg-price]');
      var cmpEl = this.querySelector('[data-capcfg-compare]');
      var saveEl = this.querySelector('[data-capcfg-save]');
      err.hidden = !!(v && v.available);
      if (!v) { saveEl.hidden = true; return; }
      var onSale = v.compare > v.price;
      priceEl.textContent = this.money(v.price);
      cmpEl.textContent = onSale ? this.money(v.compare) : '';
      cmpEl.hidden = !onSale;
      saveEl.hidden = !onSale;
      if (onSale) saveEl.textContent = 'Save ' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%';
    }
  }

  customElements.define('capisco-configurator', CapiscoConfigurator);
})();
